import { capitalizeFirstLetter } from '../../../helpers/common'

export const ADD_PAYMENT_INFO = 'add_payment_info'
export const ADD_TO_CART = 'add_to_cart'
export const ADD_TO_WISHLIST = 'add_to_wishlist'
export const COMPLETE_REGISTRATION = 'complete_registration'
export const CONTENT_VIEW = 'content_view'
export const INITIATED_CHECKOUT = 'initiated_checkout'
export const LEAD = 'lead'
export const PURCHASE = 'purchase'
export const SEARCH = 'search'
export const CONTACT = 'contact'
export const CUSTOMIZE_PRODUCT = 'customize_product'
export const DONATE = 'donate'
export const FIND_LOCATION = 'find_location'
export const SCHEDULE = 'schedule'
export const START_TRIAL = 'start_trial'
export const SUBMIT_APPLICATION = 'submit_application'
export const SUBSCRIBE = 'subscribe'
export const LISTING_INTERACTION = 'listing_interaction'
export const FACEBOOK_SELECTED = 'facebook_selected'
export const OTHER = 'other'

export const standardEvents = [
  ADD_PAYMENT_INFO,
  ADD_TO_CART,
  ADD_TO_WISHLIST,
  COMPLETE_REGISTRATION,
  CONTACT,
  CUSTOMIZE_PRODUCT,
  DONATE,
  FIND_LOCATION,
  INITIATED_CHECKOUT,
  LEAD,
  PURCHASE,
  SCHEDULE,
  SEARCH,
  START_TRIAL,
  SUBMIT_APPLICATION,
  SUBSCRIBE,
  CONTENT_VIEW
]

export const eventTypes = {
  ADD_PAYMENT_INFO,
  ADD_TO_CART,
  ADD_TO_WISHLIST,
  COMPLETE_REGISTRATION,
  CONTENT_VIEW,
  INITIATED_CHECKOUT,
  LEAD,
  PURCHASE,
  SEARCH,
  CONTACT,
  CUSTOMIZE_PRODUCT,
  DONATE,
  FIND_LOCATION,
  SCHEDULE,
  START_TRIAL,
  SUBMIT_APPLICATION,
  SUBSCRIBE,
  LISTING_INTERACTION,
  FACEBOOK_SELECTED,
  OTHER
}

const eventTypesList = Object.values(eventTypes)

export const formatCustomEventLabel = type => {
  return type
    .split('_')
    .map(word => capitalizeFirstLetter(word))
    .join(' ')
}

const customEventTypes = eventTypesList.map(type => ({
  value: type,
  label: formatCustomEventLabel(type)
}))

export default customEventTypes
